import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  step1: {
    name: "",
    country_id: "",
    city_id: null,
    address: "",
    phone: "",
    latitude: null,
    longitude: null,

    product_type_id: 7, // car rental

    car_type_id: null,
    car_brand_id: null,
    car_model_id: null,

    number_max_person: 1,
    car_condition_id: 1, 

    door_count: 1,
    seat_count: 1,
    horse_power: 50,
    mileage: 0,
    gearbox_type: "manual",
    registration_year: null,

    car_available: 1,
  },

  step2: {
    color_theme_id: null,
    short_summary: "",
    detailed_description: "",
    key_points: [],
    keyword: [],
    facilities: [],
  },

  step3: {
    booking_confirmation_mode: "",
    cancellation_policy_id: null,
    vehicle_type: "private",
    cutoff_time_booking_value: 0,
    cutoff_time_booking_unit: "minutes",
    start_date: "",
    end_date: "",
    schedules: [],
    pricing: {
      is_unified_price: true,
      price: 0,
      applicable_days: [],
    },
    charge_service: "",
    charge_service_type: "",
  },
};

// -----------------------------------------------------

function deepUpdate(obj, field, value) {
  if (obj && typeof obj === "object") {
    if (field in obj) {
      obj[field] = value;
      return true;
    }
    for (const key of Object.keys(obj)) {
      if (deepUpdate(obj[key], field, value)) return true;
    }
  }
  return false;
}

const carSlice = createSlice({
  name: "car",
  initialState,
  reducers: {
    updateCarStepField: (state, action) => {
      const { field, value } = action.payload;

      if (typeof field !== "string") {
        console.error("updateCarStepField: invalid field", field);
        return;
      }

      // Dot notation support
      if (field.includes(".")) {
        const keys = field.split(".");
        let target = state;
        for (let i = 0; i < keys.length - 1; i++) {
          if (!target[keys[i]]) return;
          target = target[keys[i]];
        }
        target[keys[keys.length - 1]] = value;
        return;
      }

      // Deep search fallback
      if (!deepUpdate(state, field, value)) {
        console.warn(`Field '${field}' not found in state`);
      }
    },

    updateCarStepBulk: (state, action) => {
      const { step, data } = action.payload;
      state[step] = { ...state[step], ...data };
    },

    setCarProductId: (state, action) => {
      state.product_id = action.payload;
      state.step2.product_id = action.payload;
      state.step3.product_id = action.payload;
    },

    resetCar: () => initialState,
  },
});

export const {
  updateCarStepField,
  updateCarStepBulk,
  setCarProductId,
  resetCar,
} = carSlice.actions;

export default carSlice.reducer;
